export default {
  state: {
    visible: false
  },
  mutations: {
    OPEN_DOWNLOAD_MODAL(state, bool) {
      state.visible = bool
    }
  },
  actions: {}
}
